import { render, staticRenderFns } from "./BillItemPreview.vue?vue&type=template&id=50af4da8&scoped=true&"
import script from "./BillItemPreview.vue?vue&type=script&lang=ts&"
export * from "./BillItemPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BillItemPreview.vue?vue&type=style&index=0&id=50af4da8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af4da8",
  null
  
)

export default component.exports